import { Record } from '../editor/record.types';
import { KEYS } from '../hooks/helpers/instructions/basic-task';

export interface IFormValidationErrors {
  key: string,
  field: string,
  type: string,
  value: any,
  test: boolean,
  message: string,
}

export const VALIDATORS = {
  DATE: 'Invalid date',
};

//  It runs basic validation for required fields
const ValidateFormFields = (
  fields: Array<Element>,
  record: Record<object>,
)
: Array<IFormValidationErrors> => {
  const requiredFields = fields.filter((field: any) => Boolean(field.required || field.isRequired));
  const dateFields = fields.filter((field: any) => field.key === KEYS.dueDate);
  let formValidationErrors: IFormValidationErrors[] = [];

  const sectionFields = fields.filter((field: any) => field.type === 'Section');
  sectionFields.forEach((section: any) => section.elements
    .forEach((element: any) => {
      if (element.required === true) {
        requiredFields.push(element);
      }
      if (element.key === KEYS.dueDate) {
        dateFields.push(element);
      }
    }));

  const fieldValue = (key: string) => {
    if (record?.form_values) {
      return record.form_values[key];
    }

    return '';
  };

  const testDateField = (key: string) => {
    if (record?.form_values) {
      return record.form_values[key] !== VALIDATORS.DATE;
    }

    return true;
  };

  // required fields validations
  formValidationErrors = requiredFields.map((field: any) => (
    field.type === 'TextField'
      ? {
        key: field.key,
        field: field.label,
        type: field.type,
        value: fieldValue(field.key),
        test: !!fieldValue(field.key) && fieldValue(field.key) !== '',
        message: 'This field is required.',
      }
      : {
        key: field.key,
        field: field.label,
        value: fieldValue(field.key),
        type: field.type,
        test: !!fieldValue(field.key),
        message: 'This field is required.',
      }
  )).filter((field: any) => field.test === false);

  // date format validations
  formValidationErrors = [
    ...formValidationErrors,
    ...dateFields
      .map((field: any) => ({
        key: field.key,
        field: field.label,
        type: field.type,
        value: fieldValue(field.key),
        test: testDateField(field.key),
        message: 'This date is invalid.',
      })).filter((field: any) => field.test === false),
  ];

  return formValidationErrors;
};

export const ValidationErrorFields = (errorArray: Array<IFormValidationErrors>) => errorArray
  .filter((error) => !error.test)
  .map((errorTested) => errorTested.field);

export default ValidateFormFields;
